<template>
    <div
    class="the-home-button absolute flex items-center faa-fade faa-opti"
    :class="{ 'faa-fade-in': ready && show }"
    v-if="showHomeButton">
        <div
        class="the-home-button-container bg-orange rounded-full p-3 pt-2 cursor-pointer"
        @click="goHome"
        @mouseover="isMapButtonHovered = true"
        @mouseleave="isMapButtonHovered = false"
        >
            <img src="@/assets/images/map-icon.svg" @load="loaded">
        </div>
        <transition       
            enter-active-class="transition-all transform duration-500 ease-out"
            leave-active-class="transition-all transform duration-500 ease-out"
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <p v-if="isMapButtonHovered" class="text-white bg-blue-dark rounded px-4 py-2 ml-4">
                Retour à la carte
            </p>
        </transition>
    </div>
</template>

<script>
    import soundEffectMixin from '@/mixins/soundEffectMixin'

    export default {
        name: 'TheHomeButton',
        mixins: [soundEffectMixin],
        data() {
            return {
                ready: false,
                show: false,
                soundEffects: {
                    home: require('../../assets/sounds/home_button.mp3'),
                },
                isMapButtonHovered: false
            }
        },
        computed: {
            showHomeButton() {
                return (this.$route.meta && this.$route.meta.showHomeButton && !this.$route.params.hideHomeButton);
            },
        },
        watch: {
            showHomeButton:{
                handler(show) {
                    setTimeout(() => {
                        this.show = show
                    }, 250)
                },
                immediate: true,
            }
        },
        methods: {
            loaded() {
                this.ready = true
            },
            goHome() {
                this.playSoundEffect('home')
                this.$router.push({ name: 'Home' })
            }
        }
    }
</script>

<style lang="scss" scoped>

.the-home-button {
    @apply mt-16;
    top: 0;
    left: 20px;

    &-container {
        @apply h-16 w-16;
        
        img {
            max-width: 100%;
            max-height: 100%;
        }
    }
}

</style>
